import MainLayout from "src/modules/adminpanel/MyLayout/Types/architect"
export default MainLayout
